<template>
  <div class="w-screen h-screen flex flex-col overflow-hidden">
    <Head>
      <Title>Vias XXI - RH Presences</Title>
      <Meta
        name="description"
        content="Vias XXI ERP - RH Presences" />
      <link
        rel="preconnect"
        href="https://fonts.googleapis.com" />
      <link
        rel="preconnect"
        href="https://fonts.gstatic.com"
        crossorigin />
      <link
        href="https://fonts.googleapis.com/css2?family=Italianno&display=swap"
        rel="stylesheet" />
      <link
        href="https://fonts.googleapis.com/css2?family=Caveat:wght@400;500;600;700&display=swap"
        rel="stylesheet" />
      <link
        href="https://fonts.googleapis.com/css2?family=Caveat:wght@400;500;600;700&family=Special+Elite&display=swap"
        rel="stylesheet" />
    </Head>

    <div class="h-12 flex flex-none items-center pl-4 bg-gray-800 shadow-lg">
      <HomeNavigation
        v-if="showHomeNavigation"
        class="mr-6" />

      <div class="w-52 pl-2">
        <nuxt-img
          provider="cloudinary"
          src="/viasxxi/images/viasxxi_wbrjaz"
          preset="webp"
          height="45px" />
      </div>

      <div class="w-full flex items-center px-8 text-orange-300 font-semibold text-xs">
        <p>Welcome {{ userData.$state.userEmail }}</p>

        <p class="px-3 text-orange-600">/</p>

        <p>Last Visit: {{ userData.$state.lastVisit.slice(0, 10) }} ({{ userData.$state.lastVisit.slice(11, 16) }})</p>

        <p class="px-3 text-orange-600">/</p>

        <p>
          <span class="mr-1">Time to expires</span>
          <span
            class="font-bold"
            v-if="counter > 300"
            >{{ counter }} (s)</span
          >
          <span
            class="text-red-400 font-bold"
            v-else
            >{{ counter }} (s)</span
          >
        </p>

        <p class="px-3 text-orange-600">/</p>

        <span class="block"
          >Today 1 Usd :
          <span>{{ globalStore.rates.USD }} Akz</span>
        </span>
      </div>

      <div class="mr-4 w-140 ml-auto flex justify-around">
        <NuxtLink
          class="nuxtLink mr-4 text-white"
          active-class="activeClass"
          to="/home"
          noPrefetch
          >Home</NuxtLink
        >
        <NuxtLink
          class="nuxtLink mr-4 text-white"
          active-class="activeClass"
          to="/tutorials"
          >Tutorials</NuxtLink
        >
        <NuxtLink
          class="nuxtLink text-white"
          active-class="activeClass"
          to="/"
          >logout</NuxtLink
        >
      </div>
    </div>

    <div class="flex-auto overflow-auto">
      <slot />
    </div>

    <div class="h-8 flex-none bg-orange-500 text-white font-semibold text-xs flex justify-between items-center px-3">
      <p>Developed by Joaquim Pedro</p>
      <p>2019 / {{ new Date().getFullYear() }}</p>
    </div>
  </div>
</template>

<script setup>
  import HomeNavigation from '@/components/home/HomeNavigation.vue'
  import { useLoginStore } from '@/stores/LoginStore'
  import { useGlobalStore } from '@/stores/GlobalStore'

  const globalStore = useGlobalStore()

  const userData = useLoginStore()

  const counter = ref(3600)

  const route = useRoute()

  const showHomeNavigation = computed(function () {
    return route.path.startsWith('/home/')
  })

  // WATCHERS

  watch(
    () => counter.value,
    (newVal, oldVal) => {
      if (userData.tokenExpires) {
        setTimeout(() => {
          counter.value = Math.floor((new Date(userData.tokenExpires) - new Date()) / 1_000)
          if (newVal < 0) {
            console.log('newVal :>> ', newVal)
            navigateTo('/')
          }
        }, 1_000)
      } else navigateTo('/')
    },
    { immediate: true }
  )

  function resetError(methodType, error) {
    console.log('resetError', methodType)

    switch (methodType) {
      case 'back':
        error.value = null

        break

      case 'home':
        navigateTo('/home')
        error.value = null

        break

      default:
        navigateTo('/')
        error.value = null
        break
    }
  }
</script>

<style scoped></style>
